<template>
  <div class="file-detector">
    <div
      v-if="comment.payload.replied_comment_id"
      :id="`reply-message-id-${comment.payload.replied_comment_id}`"
      class="chat-reply-container"
      @click.prevent="goToMessage(comment.payload.replied_comment_id)"
    >
      <div class="reply-box-left"></div>
      <div class="reply-box-right">
        <div class="replied-name">
          {{ comment.payload.replied_comment_sender_username }}
        </div>
        <div class="reply-content">
          <span
            v-if="comment.payload.replied_comment_payload.url"
            class="text-right"
            style="max-width: 100px"
          >
            <template
              v-if="
                comment.payload.replied_comment_payload.url
                  .toLowerCase()
                  .match(/\.(svg)$/)
              "
            >
              <div class="inter-medium_small-normal unsupported-svg">
                File svg tidak ditampilkan.
              </div>
            </template>
            <template v-else>
              <a
                :href="comment.payload.replied_comment_payload.url"
                rel="noopener noreferrer"
                target="_blank"
              >
                <img
                  v-if="
                    comment.payload.replied_comment_payload.url &&
                    comment.payload.replied_comment_payload.url
                      .toLowerCase()
                      .match(/\.(jpeg|jpg|gif|png)$/)
                  "
                  :src="comment.payload.replied_comment_payload.url"
                  :style="imageStyle"
                  alt="replied-comment"
                  loading="lazy"
                />
                <audio
                  v-else-if="
                    comment.payload.replied_comment_payload.url &&
                    comment.payload.replied_comment_payload.url.match(
                      /\.(m4a|mp3|ogg})$/
                    )
                  "
                  :src="comment.payload.replied_comment_payload.url"
                  :style="audioStyle"
                  controls
                ></audio>
                <video
                  v-else-if="
                    comment.payload.replied_comment_payload.url &&
                    comment.payload.replied_comment_payload.url.match(
                      /\.(mp4|avi|3gp})$/
                    )
                  "
                  :src="comment.payload.replied_comment_payload.url"
                  :style="videoStyle"
                  controls
                ></video>
                <span v-else>
                  {{ comment.payload.replied_comment_payload.file_name }}
                  <font-awesome-icon
                    icon="download"
                    class="ml-2"
                  />
                </span>
              </a>
            </template>
            <div :style="captionStyle">
              {{ comment.payload.replied_comment_payload.caption }}
            </div>
          </span>
          <span
            v-else
            :style="textStyle"
            v-html="renderMessage(comment.payload.replied_comment_message)"
          ></span>
        </div>
      </div>
    </div>
    <span
      v-if="comment.payload.url"
      class="text-right"
      style="max-width: 100px"
    >
      <template v-if="comment.payload.url.toLowerCase().match(/\.(svg)$/)">
        <div class="inter-medium_small-normal unsupported-svg">
          File svg tidak ditampilkan.
        </div>
      </template>
      <template v-else>
        <a
          :href="comment.payload.url"
          rel="noopener noreferrer"
          class="text-decoration-none text-filter-royal-navy-400"
          target="_blank"
        >
          <img
            v-if="
              comment.payload.url &&
              comment.payload.url.match(/\.(jpeg|jpg|gif|png)$/)
            "
            :src="comment.payload.url"
            :style="imageStyle"
            alt="replied-comment"
            loading="lazy"
          />
          <audio
            v-else-if="
              comment.payload.url &&
              comment.payload.url.match(/\.(m4a|mp3|ogg})$/)
            "
            :src="comment.payload.url"
            :style="audioStyle"
            controls
          ></audio>
          <video
            v-else-if="
              comment.payload.url &&
              comment.payload.url.match(/\.(mp4|avi|3gp})$/)
            "
            :src="comment.payload.url"
            :style="videoStyle"
            controls
          ></video>
          <span v-else>
            {{ comment.payload.file_name }}
            <img
              src="https://cdn.karier.mu/assets/v3/icon/box-arrow-down.svg"
              class="s-ml-1 mr-4 text-filter-royal-navy-400"
              height="14px"
              width="14px"
              alt="Icon Download"
              loading="lazy"
            >
          </span>
        </a>
      </template>
      <div :style="captionStyle">{{ comment.payload.caption }}</div>
    </span>
    <span
      v-else
      :class="{ 'ff-primary fs-14 fw-400': fromTanyamuKelasV2 }"
      :style="textStyle"
      class="inter-medium_small-normal"
      v-html="renderMessage(comment.message)"
    ></span>
    <div
      :style="{
        top: optionChevronTop || `-2px`,
        right: optionChevronRight || `-20px`,
      }"
      class="my-chat-option"
      @click.prevent="openChatOption = !openChatOption"
    >
      <img
        alt="Sekolah.mu"
        src="https://cdn.karier.mu/assets/tanyamu/icon/Main-Chevron.svg"
      />
    </div>
    <transition name="fade">
      <div
        v-if="openChatOption && !isMobile"
        :style="{
          position: `absolute`,
          top: optionBoxTop,
          right: optionBoxRight,
        }"
        class="my-chat-optionbox"
      >
        <div
          class="list-label"
          id="reply-message"
          @click.prevent="handleReplyMessage"
        >
          Balas pesan
        </div>
        <div
          v-if="canDeleteOthersMessage || String(comment.email) === String(userId)"
          id="delete-message"
          class="list-label"
          @click.prevent="handleDeleteMessage"
        >
          Hapus pesan
        </div>
      </div>
    </transition>
    <bottom-sheet-message-action
      :is-shown="openChatOption && isMobile"
      @reply="handleReplyMessage"
      @delete="handleDeleteMessage"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import deviceDetector from 'mobile-device-detect'
import { renderMention } from '@/functions/chatHelper'

export default {
  // props: ['comment', 'fromFloating'],
  props: {
    comment: {
      type: Object,
      required: true
    },
    fromFloating: {
      type: Boolean,
      default: null
    },
    optionBoxTop: {
      type: String,
      default: '0px'
    },
    optionBoxRight: {
      type: String,
      default: '0px'
    },
    optionChevronTop: {
      type: String,
      default: '0px'
    },
    optionChevronRight: {
      type: String,
      default: '0px'
    },
    fromTanyamuKelasV2: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      imageStyle: {
        maxWidth: '300px'
      },
      textStyle: {
        whiteSpace: 'pre-line',
        wordBreak: 'break-word'
      },
      audioStyle: {},
      videoStyle: {},
      captionStyle: {
        whiteSpace: 'pre-line',
        maxWidth: '300px',
        textAlign: 'left',
        marginTop: '8px',
        wordBreak: 'break-word',
        fontSize: '14px'
      },
      openChatOption: false,
      isMobile: deviceDetector.isMobile
    }
  },
  components: {
    FontAwesomeIcon,
    BottomSheetMessageAction: defineAsyncComponent(() => import('@/components/tanyamu/parts/BottomSheetMessageAction'))
  },
  emits: ['deleteMessage', 'replyMessage'],
  methods: {
    handleReplyMessage () {
      this.$emit('replyMessage', this.comment)
      this.openChatOption = false
      document.getElementById('text-editor').focus()
    },
    handleDeleteMessage () {
      this.$emit(
        'deleteMessage',
        this.comment.room_id,
        this.comment.unique_temp_id
      )
      this.openChatOption = false
    },
    renderMessage (text) {
      const filtered = this.$XSSFilter(text)
      const urlRegex = /(https?:\/\/[^\s]+)/g
      return renderMention(filtered.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>'
      }))
    },
    goToMessage (messageId) {
      const childElement = document.getElementById(`message-id-${messageId}`)
      childElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      childElement.classList.add('highlight-message')
      setTimeout(() => {
        childElement.classList.remove('highlight-message')
      }, 1200)
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.openChatOption = false
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    userId () {
      return this.$store.state.storage.userId
    },
    canDeleteOthersMessage () {
      if (this.userInfo.role.length) {
        if (
          this.userInfo.role.some(
            (item) =>
              item.label === 'Super Admin' ||
              item.label === 'Admin Sekolahmu' ||
              item.label === 'Fasilitator'
          )
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  created () {
    if (this.fromFloating) {
      this.imageStyle.maxWidth = '215px'

      this.textStyle.wordBreak = 'break-word'
      this.textStyle.fontWeight = 'normal'
      this.textStyle.fontSize = '14px'
      this.textStyle.lineHeight = '19px'
      this.textStyle.color = 'rgba(0, 0, 0, 0.7)'

      this.audioStyle.maxWidth = '215px'

      this.videoStyle.maxWidth = '215px'

      this.captionStyle.maxWidth = '215px'
    } else if (this.fromTanyamuKelasV2) {
      this.imageStyle.maxWidth = '300px'
      this.imageStyle.width = '100%'

      this.textStyle.wordBreak = 'break-word'
      this.textStyle.lineHeight = '19px'

      this.audioStyle.maxWidth = '245px'

      this.videoStyle.maxWidth = '245px'

      this.captionStyle.maxWidth = '245px'
    } else {
      this.imageStyle.maxWidth = '255px'
      this.videoStyle.maxWidth = '255px'
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style scoped>
.file-detector {
  font-family: "Inter", "Open Sans", sans-serif !important;
  position: relative;
}

.my-chat-option {
  position: absolute;
  cursor: pointer;
}

.my-chat-option img {
  width: 18px;
}

.my-chat-optionbox {
  width: 120px;
  padding: 12px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(51, 51, 51, 0.1);
  background-color: var(--color-neutral-100);
  z-index: 100;
}

.my-chat-optionbox .list-label {
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
}

.my-chat-optionbox .list-label:hover {
  color: var(--color-royal-navy-300);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.chat-reply-container {
  margin-bottom: 9px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.reply-box-left {
  background: var(--color-royal-navy-400);
  width: 3px;
  margin-right: 8px;
  border-radius: 15px;
}

.chat-reply-container .replied-name {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: var(--color-text-primary);
  margin-bottom: 9px;
}

.chat-reply-container .reply-content {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: var(--color-text-primary);
}

.unsupported-svg {
  color: var(--secondary-font-color);
  background: var(--color-ui-element-grey-4);
  padding: 2px 14px;
  border-radius: 24px;
}

.inter-medium_small-normal {
  color: var(--color-text-primary) !important;
}

a {
  color: var(--color-royal-navy-500);
}

.user-mention {
  cursor: pointer !important;
  text-transform: none;
}
</style>
